import React from 'react'
import { useThemeTokens } from '../../themes'

interface BadgeProps {
  children: React.ReactNode
  variant?: 'draft' | 'submitted' | 'confirmed' | 'billed' | 'completed' | 'default' | 'warning'
  className?: string
  style?: React.CSSProperties
}

export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'default',
  className = '',
  style = {}
}) => {
  const theme = useThemeTokens()
  
  const baseStyles: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
    borderRadius: theme.borderRadius.lg,
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.medium,
    fontFamily: theme.typography.fontFamily,
  }
  
  const variantStyles: Record<string, React.CSSProperties> = {
    draft: {
      backgroundColor: theme.colors.statusDraft + '20', // 20% opacity
      color: theme.colors.statusDraft,
    },
    submitted: {
      backgroundColor: theme.colors.statusSubmitted + '20',
      color: theme.colors.statusSubmitted,
    },
    confirmed: {
      backgroundColor: theme.colors.statusConfirmed + '20',
      color: theme.colors.statusConfirmed,
    },
    billed: {
      backgroundColor: theme.colors.statusBilled + '20',
      color: theme.colors.statusBilled,
    },
    completed: {
      backgroundColor: theme.colors.statusCompleted + '20',
      color: theme.colors.statusCompleted,
    },
    default: {
      backgroundColor: theme.colors.secondary + '20',
      color: theme.colors.secondary,
    },
    warning: {
      backgroundColor: '#fef3c7', // Light yellow background
      color: '#f59e0b', // Orange text
    }
  }
  
  const combinedStyles: React.CSSProperties = {
    ...baseStyles,
    ...variantStyles[variant],
    ...style
  }
  
  return (
    <span style={combinedStyles} className={className}>
      {children}
    </span>
  )
} 